import { useTranslation } from "react-i18next";
import {
  Dialog as ShadcnDialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
  DialogTrigger,
} from "../ui/dialog";
import { Button } from "../ui";
import type { DialogProps } from "~/types/ui";

export function Dialog({
  trigger = undefined,
  externalTrigger = false,
  defaultActions = false,
  actions,
  title,
  description,
  children,
  maxWidth = "100%",
  width = "450px",
  maxHeight = "90vh",
  className = "",
  open,
  onOpenChange = () => {},
  onSubmit = () => {},
  submitDisabled = false,
}: DialogProps) {
  return (
    <ShadcnDialog open={open} onOpenChange={onOpenChange}>
      {!externalTrigger && (
        <DialogTrigger className={className} asChild>
          {trigger}
        </DialogTrigger>
      )}

      <DialogContent
        className="text-left"
        style={{
          width: width,
          maxWidth: maxWidth,
          maxHeight: maxHeight,
          overflowY: "scroll",
        }}
      >
        <DialogHeader>
          <DialogTitle>{title}</DialogTitle>
          {description && <DialogDescription>{description}</DialogDescription>}
        </DialogHeader>
        {children}
        <DialogFooter>
          {actions ? (
            actions
          ) : defaultActions ? (
            <DialogActions
              onSubmit={onSubmit}
              submitDisabled={submitDisabled}
              onCancel={() => onOpenChange(false)}
            />
          ) : null}
        </DialogFooter>
      </DialogContent>
    </ShadcnDialog>
  );
}

export function DialogActions({
  onSubmit,
  onCancel,
  submitDisabled = false,
}: {
  onSubmit: () => void;
  onCancel: () => void;
  submitDisabled?: boolean;
}) {
  const { t } = useTranslation();
  return (
    <div className="flex w-full justify-end space-x-2">
      <Button variant="ghost" onClick={() => onCancel()}>
        {t("common.cancel")}
      </Button>
      <Button variant="default" disabled={submitDisabled} onClick={onSubmit}>
        {t("common.confirm")}
      </Button>
    </div>
  );
}
